import React, { useContext, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'underscore';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withPerfMarker } from '@bingads-webui/performance-marker-react-wrapper';
import { ThirdPartyTagView } from '@bingads-webui-campaign-react/edit-website-pages';
import { ConversionHelpProvider } from '@bingads-webui-campaign-react/conversion-help';
import { getStepStyles } from '@bingads-webui-campaign-react/conversion-wizard-components';
import { StepContainer } from '../step-container/step-container';
import { WIZARD_ACTIONS } from '../../goal-creation-wizard-reducer';
import { GoalCreationWizardContext } from '../../goal-creation-wizard-context';

const TagSetupThirdPartyInstructionStepUnstyled = (props) => {
  const {
    selectedPlatform,
  } = props;

  const wizardContext = useContext(GoalCreationWizardContext);
  const i18n = useContext(I18nContext);

  const {
    goalContext: {
      Type, GoalValueType, Tag: { Id }, IsEnhancedConversionsEnabled,
    },
  } = wizardContext;
  const { logActivity } = wizardContext;

  const closeApexHelpContent = useCallback(() => {
    if (document.querySelector('#apexHelpContainer span.close_button')) {
      document.querySelector('#apexHelpContainer span.close_button').click();
    }
  }, []);

  const handleNext = useCallback(() => {
    closeApexHelpContent();

    const goToEventTagSetup = Type === 'EventGoal' || Type === 'ProductConversionGoal'
    || GoalValueType === 'VariantValue';
    const enhancedConversions = wizardContext.permissions && wizardContext.permissions.dynamic && wizardContext.permissions.dynamic.EnhancedConversions;
    if (enhancedConversions && IsEnhancedConversionsEnabled) {
      wizardContext.dispatch({
        type: WIZARD_ACTIONS.NAVIGATE_TO_SETUP_ENHANCED_CONV,
      });
    } else {
      wizardContext.dispatch({
        type: goToEventTagSetup ?
          WIZARD_ACTIONS.NAVIGATE_WITH_TAG_INSTALL_INSTRUCTIONS : WIZARD_ACTIONS.WIZARD_NAVIGATE_NEXT,
      });
    }
  }, [GoalValueType, IsEnhancedConversionsEnabled, Type, closeApexHelpContent, wizardContext]);

  const handleCancel = useCallback(() => {
    closeApexHelpContent();
    wizardContext.exitWizard(selectedPlatform);
  }, [closeApexHelpContent, wizardContext, selectedPlatform]);

  const footerConfig = useMemo(() => ({
    buttons: [{
      type: 'Secondary',
      onClick: () => {
        closeApexHelpContent();
        wizardContext.goBack();
      },
      isEnabled: true,
      text: i18n.getString(_TL_(('Back'))),
    },
    {
      type: 'Primary',
      onClick: handleNext,
      isEnabled: true,
      text: i18n.getString(_TL_(('Next'))),
    },
    {
      type: 'Cancel',
      onClick: handleCancel,
      isEnabled: true,
      text: i18n.getString(_TL_(('Cancel'))),
    }],
  }), [i18n, handleNext, handleCancel, closeApexHelpContent, wizardContext]);

  const handleCopyCallback = () => {};

  const helpIds = {
    emailPlatform: {
      Container: {
        WordPress: 'app30014',
        Wix: 'app30013',
        Shopify: 'app30012',
        BigCommerce: 'app30011',
      },
      UET: {
        WordPress: 'app54735',
        Wix: 'app54736',
        Shopify: 'app54737',
        BigCommerce: 'app54738',
      },
    },
  };

  const tagContext = {
    data: {
      id: Id,
      type: 'UET',
    },
    isLoading: false,
    error: null,
    getTag: noop,
    createTag: noop,
  };

  return (
    <StepContainer
      subContainer
      step="tag-setup-selection"
      footerConfig={footerConfig}
      title={i18n.getString(_TL_('Insert the tracking tag using a website editing platform'))}
    >
      <ConversionHelpProvider helpIds={helpIds}>
        <ThirdPartyTagView
          tagContext={tagContext}
          selectedPlatform={selectedPlatform}
          isSmartOrExpertMode
          onCopyCallback={handleCopyCallback}
          permissions={wizardContext.permissions}
          serverContext={wizardContext.serverContext}
          logTrace={logActivity && logActivity.trace}
          deps={{}}
        />
      </ConversionHelpProvider>
    </StepContainer>

  );
};

TagSetupThirdPartyInstructionStepUnstyled.propTypes = {
  selectedPlatform: PropTypes.string.isRequired,
};

export const TagSetupThirdPartyInstructionStep = withPerfMarker(withDefaultStyles(TagSetupThirdPartyInstructionStepUnstyled, getStepStyles));
